import { createGlobalStyle } from 'styled-components';

const DRAG_HOVER_BG = '#b3c2c9ff';

export const CategoryTableStyles = createGlobalStyle`
  .drag-over-active > th, 
  .drag-over-active > td {
    background-color: ${DRAG_HOVER_BG} !important;
  }
  
  .reordering-mode-active th > div[data-role="flat-table-row-header-content"] {
    display: flex !important;
    align-items: center !important;
  }

  .reordering-mode-active th > div[data-role="flat-table-row-header-content"] > .row-drag-handle {
    order: 1;
    margin-right: 8px;
    cursor: grab;
  }

  .reordering-mode-active th > div[data-role="flat-table-row-header-content"] > span[data-element^="chevron"] {
    order: 2;
    margin-right: 8px;
  }

  .reordering-mode-active th > div[data-role="flat-table-row-header-content"] > .row-text-content {
    order: 3;
  }

  [data-element="updating-coa-row"] {
    opacity: 0.5;
    transition: opacity 0.2s ease-in-out;
    pointer-events: none; /* Physically blocks all clicks and hovers inside the row! */
  }
`;
